import get from 'lodash/get';
import { format } from '../../../../../utils';
import { ContentAlignment, TableColumn, ColumnDef } from '../..';
import { CellTypeStrategy, getDefaultColumnDefParamsType } from '../models';
import { DEFAULT_EMPTY_CELL_PLACEHOLDER } from '../../constants';

export class TimestampCell<TData> implements CellTypeStrategy<TData> {
  public getDefaultColumnDef({
    col,
    isClientSideData,
    metadata,
  }: getDefaultColumnDefParamsType<TData>): Partial<ColumnDef<TData>> {
    return {
      valueFormatter: param => {
        const value = get(param, 'value');
        if (value == null) {
          return DEFAULT_EMPTY_CELL_PLACEHOLDER;
        }
        const valueFormatEnabled = col?.valueFormatterOptions?.enabled;
        if (valueFormatEnabled) {
          const type = col?.valueFormatterOptions?.formatAs?.type ?? 'dateTime';
          return String(format(type, value, col?.valueFormatterOptions?.formatAs?.options));
        }
        return String(value);
      },
      sortable: isClientSideData,
      // meta: {
      //   align: ContentAlignment.LEFT,
      // },
    };
  }
}
